<template>
    <div>
        <br/>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        v-model="search.vendor"
                        class="form-control border-0"
                        :options="optionVendor"
                        :customLabel="LabelVendor"
                        label="name"
                        placeholder="ค้นหาผู้จำหน่าย"
                        track-by="name">
                    </multiselect>
                    <input type="text"
                           placeholder="ค้นหาโครงการ"
                           v-model="search.name"
                           class="form-control"/>
                    &nbsp;
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp;
                    <button @click="searchPayment"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="goToPaymentForm()"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        สร้างโครงการ
                    </button>
                    &nbsp
                    <button @click="printExcel()"
                            class="btn btn-secondary my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon>
                        รายงาน Excel
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">โครงการ</th>
                    <th scope="col">วันที่ตั้งเบิก</th>
                    <th scope="col">ผู้จำหน่าย</th>
                    <th scope="col">ยอดตั้ง</th>
                    <th scope="col">ยอดจ่ายจริง</th>
                    <th scope="col">คงเหลือ</th>
                    <th scope="col">ผู้ตั้งเบิก</th>
                    <th scope="col">จำนวนรายการ</th>
                    <th scope="col">สถานะชำระ</th>
                    <th scope="col">ข้อมูล</th>
                    <th scope="col">แก้ไข/ลบ</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(data,index) in paymentList">
                    <tr>
                        <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                        <td>{{ data.name }}</td>
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td>
                            <template v-if="data.vendor">
                                {{ data.vendor.name }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>{{ data.amount_total | currency }}</td>
                        <td>{{ data.amount_paid | currency }}</td>
                        <td>{{ data.balance | currency }}</td>
                        <td>
                            <template v-if="data.user">
                                {{ data.user.name }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>{{ data.count | amount }}</td>
                        <td>
                            <template v-if="data.status==1"
                                      style="color: red">
                                <span style="color: red;">{{ data.status_name }}</span>
                            </template>
                            <template v-if="data.status==2">
                                <span style="color: green;">{{ data.status_name }}</span>
                            </template>
                        </td>
                        <td>
                            <template v-if="data.show==0">
                                <button class="btn btn-info"
                                        v-on:click="() => { data.show = 1,
                                        payment_id = data.id }">
                                    แสดง
                                </button>
                            </template>
                            <template v-if="data.show==1">
                                <button class="btn btn-info"
                                        v-on:click="() => { data.show = 0}">
                                    ซ่อน
                                </button>
                            </template>
                        </td>
                        <td>
                            <a @click="goToPaymentForm(data.id)">
                                <icon name="pencil-alt">
                                </icon>
                            </a>
                        </td>
                    </tr>
                    <tr v-if="data.show==1">
                        <td></td>
                        <td colspan="10">
                            <table align="center" style="background-color: white"
                                   v-if="data.payment_details.length > 0">
                                <tr class="heading-table">
                                    <th scope="col">ลำดับ</th>
                                    <th width="200px" scope="col">รายการเบิก</th>
                                    <th scope="col">ยอดเบิก</th>
                                    <th scope="col">วันที่ชำระ</th>
                                    <th scope="col">ผู้ตั้งเบิก</th>
                                    <th scope="col">สถานะชำระ</th>
                                    <th scope="col" style="width: 15%">แก้ไข/ลบ</th>
                                </tr>
                                <template v-for="(info,index) in data.payment_details">
                                    <tr>
                                        <td>{{ ++index }}</td>
                                        <td>{{ info.name }}</td>
                                        <td>{{ info.amount | currency }}</td>
                                        <td>
                                            <template v-if="info.payment_date">
                                                {{ info.payment_date | moment("DD/MM/YYYY") }}
                                            </template>
                                            <template v-else>-</template>
                                        </td>
                                        <td>
                                            <template v-if="info.user">
                                                {{ info.user.name }}
                                            </template>
                                            <template v-else>-</template>
                                        </td>
                                        <td>
                                            <template v-if="info.status==1"
                                                      style="color: red">
                                                <span style="color: red;">{{ info.status_name }}</span>
                                            </template>
                                            <template v-if="info.status==2">
                                                <span style="color: green;">{{ info.status_name }}</span>
                                            </template>
                                        </td>
                                        <td>
                                            <button @click="showUpdateDetailsModal(info.id)"
                                                    style="background-color: transparent;border: none"
                                                    :disabled="info.status==2">
                                                <icon name="pencil-alt">
                                                </icon>
                                            </button>
                                            <button @click="showDeleteDetailsModal(info.id)"
                                                    style="background-color: transparent;border: none"
                                                    :disabled="info.status==2">
                                                <icon name="trash">
                                                </icon>
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </td>
                        <td>
                            <div>
                                <button class="btn btn-danger"
                                        @click="showCreateDetailsModal(data.id)">
                                    +สร้างรายการเบิก
                                </button>
                            </div>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div v-if="paymentList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPayment">
            </vue-pagination>
        </div>
        <br>
        <br/>
        <!--สร้างรายการเบิก-->
        <b-modal
            hide-footer
            ref="create_list"
            title="สร้างรายการเบิก">
            <div class="col-sm-12">
                <b-row>
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>รายการเบิก</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input class="form-control"
                               v-model="form.name"
                               type="text"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>ยอดเบิก</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input class="form-control"
                               v-model="form.amount"
                               type="text"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>วันที่ชำระ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 form-inline">
                        <date-picker
                            v-model="form.payment_date"
                            type="date"
                            format="DD/MM/YYYY"
                            lang="en"
                            placeholder="วันที่ชำระ">
                        </date-picker>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button type="button"
                                @click="savePaymentDetails"
                                class="btn btn-success">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp&nbsp
                        <button type="button"
                                @click="hideCreateDetailsModal"
                                class="btn btn-outline-secondary">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
        </b-modal>
        <!--Update รายการเบิก-->
        <b-modal
            hide-footer
            ref="update_detail"
            title="แก้ไขรายการเบิก">
            <div class="col-sm-12">
                <b-row>
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>รายการเบิก</label>
                    </b-col>
                    <b-col sm="7" class="col-sm-7">
                        <input class="form-control"
                               v-model="form.name"
                               type="text"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>ยอดเบิก</label>
                    </b-col>
                    <b-col sm="7" class="col-sm-7">
                        <input class="form-control"
                               v-model="form.amount"
                               type="text"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>วันที่ชำระ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 form-inline">
                        <date-picker
                            v-model="form.payment_date"
                            type="date"
                            format="DD/MM/YYYY"
                            lang="en"
                            placeholder="วันที่อัพเดต">
                        </date-picker>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button type="button"
                                @click="savePaymentDetails()"
                                class="btn btn-success">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp&nbsp
                        <button type="button"
                                @click="hideUpdateDetailsModal"
                                class="btn btn-outline-secondary">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
        </b-modal>
        <!---ลบรายการ detail-->
        <b-modal hide-header hide-footer ref="delete_detail">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    @click="deleteDetail"
                    type="button"
                    class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteDetailsModal"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ paymentList }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import moment from "moment";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";

export default {

    name: "payment-list",
    props: {showActionButtons: {type: Boolean, default: true}},
    created() {
        this.$store.dispatch('PurchasePayment/setPayment');
        this.$store.dispatch('Vendor/getVendorAll')
        this.getCurrentDate();
    },
    components: {
        Multiselect,
        DatePicker,
        VuePagination,
    },
    data() {
        return {
            payment_id: "",
            activeCloseDate: false,
            event_submit: false,
            dateFormat: 'D/MM/YYYY',
            id: null,
            delete_item: "",
            form: {
                date: "",
                payment_date: "",
                name: "",
                amount: "",
            },
            texts: {
                apply: 'Apply',
                cancel: 'Cancel',
                keyboardShortcuts: 'Keyboard Shortcuts',
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            paymentList: state => {
                return state.PurchasePayment.paymentList
            },
            user: state => {
                return state.Auth.user;
            },
            optionVendor: state => {
                return state.Vendor.vendorAll;
            },
            search: state => {
                return state.PurchasePayment.search;
            },
            dataPaginate: state => {
                return state.PurchasePayment.dataPaginate;
            },
        })
    },
    methods: {
        LabelVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        clearPaymentDate() {
            this.form.payment_date = "";
        },
        resetDetailModal() {
            this.detail_id = null;
            this.form = {
                date: "",
                payment_date: new Date(),
                name: "",
                amount: "",
            };
        },
        apply() {
            this.$emit('apply')
        },
        cancel() {
            this.$emit('cancelled')
        },
        showCreateDetailsModal(id) {
            this.payment_id = id;
            this.resetDetailModal();
            this.$refs.create_list.show();
        },
        showUpdateDetailsModal(id) {
            this.detail_id = id;
            this.$store.dispatch("PurchasePayment/showDetails", this.detail_id).then(res => {
                this.form = res;
            });
            this.$refs.update_detail.show();
        },
        hideUpdateDetailsModal() {
            this.$refs.update_detail.hide();
            this.detail_id = null;
        },
        showDeleteDetailsModal(id) {
            this.detail_id = id;
            this.$refs.delete_detail.show();
        },
        hideDeleteDetailsModal() {
            this.$refs.delete_detail.hide();
            this.detail_id = null;
        },
        hideCreateDetailsModal() {
            this.$refs.create_list.hide();
        },
        showDeleteModal(id) {
            this.delete_item = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        savePaymentDetails() {
            if (!this.form.name) {
                alert("กรุณากรอกรายการเบิก")
            } else if (!this.form.payment_date) {
                alert("กรุณาใส่วันที่")
            } else if (!this.form.amount) {
                alert("กรุณาใส่ยอดเบิก")
            } else {
                if (this.form.payment_date) {
                    this.form.payment_date = moment(this.form.payment_date).format("YYYY-MM-DD");
                } else {
                    this.form.payment_date = "";
                }
                let info = {
                    payment_id: this.payment_id,
                    name: this.form.name,
                    date: this.form.payment_date,
                    amount: this.form.amount,
                    status: 1,
                    payment_date: this.form.payment_date,
                    user_id: this.user.id
                };
                if (this.detail_id !== null) {
                    return this.$store.dispatch('PurchasePayment/savePaymentDetails', {
                        id: this.detail_id,
                        data: info
                    }).then(data => {
                        if (!data) {
                            alert("คุณใส่จำนวนเกินกว่ายอดตั้งที่ต้องการเบิก")
                        } else {
                            this.hideUpdateDetailsModal();
                            this.$store.dispatch('PurchasePayment/setPayment');
                        }
                    })
                } else {
                    return this.$store.dispatch('PurchasePayment/savePaymentDetails', {
                        data: info
                    }).then(data => {
                        if (!data) {
                            alert("คุณใส่จำนวนเกินกว่ายอดตั้งที่ต้องการเบิก")
                        } else {
                            this.hideCreateDetailsModal();
                            this.$store.dispatch('PurchasePayment/setPayment');
                        }
                    })
                }
            }
        },
        deleteDetail() {
            this.$store.dispatch("PurchasePayment/deletePaymentDetails", this.detail_id).then(() => {
                this.hideDeleteDetailsModal();
                this.$store.dispatch('PurchasePayment/setPayment');
            });
        },
        getCurrentDate() {
            const currentDate = moment().format("YYYY-MM-DD");
            this.form.date = currentDate;
            this.form.payment_date = currentDate;
        },
        goToPaymentForm(id) {
            if (id) {
                let route = this.$router.resolve({
                    name: "payment-form",
                    query: {id: window.btoa(id)}
                });
                window.open(route.href, '_blank');
            } else {
                let route = this.$router.resolve({
                    name: "payment-form",
                });
                window.open(route.href, '_blank');
            }
        },
        searchPayment() {
            this.event_submit = true;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            let data = {
                name: this.search.name,
                vendor_id: "",
                date: this.search.date
            };
            if (this.search.vendor) {
                data.vendor_id = this.search.vendor.id;
            }

            this.$store.dispatch("PurchasePayment/search", data)
        },
        printExcel() {
            this.event_submit = true;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            let data = {
                name: this.search.name,
                vendor_id: "",
                date: this.search.date,
                excel: 'excel',
            };
            if (this.search.vendor) {
                data.vendor_id = this.search.vendor.id;
            }
            window.open(domain + "/payment_search?date=" + data.date + "&name=" + data.name + "&vendor_id=" + data.vendor_id + "&excel=" + data.excel)
        },
        getPayment() {
            const page = this.dataPaginate.current_page;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            let data = {
                page: page,
                name: this.search.name,
                vendor_id: "",
                date: this.search.date
            };
            if (this.search.vendor) {
                data.vendor_id = this.search.vendor.id;
            }
            //paginate search
            if (this.event_submit) {
                this.$store.dispatch('PurchasePayment/search', data)
            }
            //paginate get data
            else {
                this.$store.dispatch('PurchasePayment/setPayment', page)
            }
        },
    }
}
</script>

<style scoped>
.heading-table {
    background-color: #CDC4C4;
}

.border-left-0 {
    border-left: 0;
}
</style>
